import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../app/api';

const initialState = {
    bankingFees: [],
    loading: false,
    error: null
};

export const getBankingFees = createAsyncThunk(
    'bankingFees/getBankingFees',
    async ({ company_id }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/banking-fee/get-banking-fees`, { params: { company_id } });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const addBankingFee = createAsyncThunk(
    'bankingFees/addBankingFee',
    async ({ bankAccount, fee, date, company_id }, { rejectWithValue }) => {
        try {
            const response = await api.post('/banking-fee/add-banking-fee', { bankAccount, fee, date, company_id });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const updateBankingFee = createAsyncThunk(
    'bankingFees/updateBankingFee',
    async ({ id, bankAccount, fee, date, company_id }, { rejectWithValue }) => {
        try {
            const response = await api.put('/banking-fee/update-banking-fee', { id, bankAccount, fee, date, company_id });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const deleteBankingFee = createAsyncThunk(
    'bankingFees/deleteBankingFee',
    async ({ id, company_id }, { rejectWithValue }) => {
        try {
            await api.delete(`/banking-fee/delete-banking-fee/${id}`, { params: { company_id } });
            return id;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

const bankingFeeSlice = createSlice({
    name: 'bankingFees',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBankingFees.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBankingFees.fulfilled, (state, action ) => {
                state.loading = false;
                state.error = null;
                state.bankingFees = action.payload;
            })
            .addCase(getBankingFees.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.bankingFees = [];
            })
            .addCase(addBankingFee.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addBankingFee.fulfilled, (state, action) => {
                state.loading = false;
                state.bankingFees = [...state.bankingFees, action.payload];
                state.error = null;
            })
            .addCase(addBankingFee.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateBankingFee.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateBankingFee.fulfilled, (state, action) => {
                state.loading = false;
                state.bankingFees = state.bankingFees.map(fee => fee.id === action.payload.id ? action.payload : fee);
            })
            .addCase(updateBankingFee.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteBankingFee.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBankingFee.fulfilled, (state, action) => {
                state.loading = false;
                state.bankingFees = state.bankingFees.filter(fee => fee.id !== action.payload.id);
                state.error = null;
            })
            .addCase(deleteBankingFee.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export const { } = bankingFeeSlice.actions;
export default bankingFeeSlice.reducer;